"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../context");

var _utils = require("../../utils");

var _constants = require("../html/constants");

var _constants2 = require("../constants");

var _expandable = require("../expandable");

var _CardItem = _interopRequireDefault(require("./CardItem"));

var _core = require("@emotion/core");

var _excluded = ["aria-labelledby", "data", "getRowAttributes", "isStriped", "renderCardForRow", "shouldAutoCollapseOnExpand", "spacing", "aria-label", "aria-describedby"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CardList = (0, _context.styledWithTheme)('ul')(function (_ref) {
  var theme = _ref.theme,
      isStriped = _ref.isStriped;
  var stripedProps = isStriped ? {
    '& > div:nth-of-type(even)': {
      backgroundColor: theme.selectors.color(_constants.BACKGROUND_SHADE_COLOR)
    }
  } : {};
  return _objectSpread({
    borderRadius: theme.selectors.radius(_constants.TABLE_RADIUS),
    backgroundColor: theme.selectors.color('neutral0'),
    border: "".concat(_constants.BORDER_WIDTH_OUTER, "px solid ").concat(theme.selectors.color(_constants.TABLE_BORDER_COLOR)),
    listStyle: 'none',
    padding: 0,
    margin: 0
  }, stripedProps);
});
CardList.displayName = 'CardList';

var CardLayoutBase = function CardLayoutBase(_ref2) {
  var ariaLabelledby = _ref2['aria-labelledby'],
      data = _ref2.data,
      _ref2$getRowAttribute = _ref2.getRowAttributes,
      getRowAttributes = _ref2$getRowAttribute === void 0 ? _constants2.defaultProps.getRowAttributes : _ref2$getRowAttribute,
      isStriped = _ref2.isStriped,
      renderCardForRow = _ref2.renderCardForRow,
      shouldAutoCollapseOnExpand = _ref2.shouldAutoCollapseOnExpand,
      spacing = _ref2.spacing,
      ariaLabel = _ref2['aria-label'],
      ariaDescribedBy = _ref2['aria-describedby'],
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  var _useState = (0, _react.useState)((0, _expandable.mapIndexesToBooleans)(data)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expandedRows = _useState2[0],
      setExpandedRows = _useState2[1];

  var toggleExpanded = function toggleExpanded(index) {
    setExpandedRows(_objectSpread(_objectSpread({}, shouldAutoCollapseOnExpand ? (0, _expandable.setAllValuesToFalse)(expandedRows) : expandedRows), {}, (0, _defineProperty2.default)({}, index, !expandedRows[index])));
  };

  (0, _react.useEffect)(function () {
    setExpandedRows((0, _expandable.mapIndexesToBooleans)(data));
  }, [data]);
  return (0, _core.jsx)(CardList, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    "aria-labelledby": ariaLabelledby,
    isStriped: isStriped,
    role: "list",
    "aria-label": ariaLabel,
    "aria-describedby": ariaDescribedBy
  }), data.map(function (dataItem, index) {
    return (0, _core.jsx)(_CardItem.default, {
      key: index,
      getRowAttributes: getRowAttributes,
      data: dataItem,
      index: index,
      toggleExpanded: toggleExpanded,
      renderCardForRow: renderCardForRow,
      spacing: spacing,
      isExpanded: expandedRows[index]
    });
  }));
};

var CardLayout = (0, _utils.withTestAttributes)({})(CardLayoutBase);
CardLayout.displayName = 'CardLayout';
var _default = CardLayout;
exports.default = _default;